var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEllipsis = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 3,
  viewBox: "0 0 15 3"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Zm6,0A1.5,1.5,0,1,1,6,1.5,1.5,1.5,0,0,1,7.5,0Zm6,0A1.5,1.5,0,1,1,12,1.5,1.5,1.5,0,0,1,13.5,0Z",
  fill: "#e3e4e5"
})));
export default SvgIconEllipsis;